/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Exported_CsvInputs */

const en_knp_terms_exported_csv = /** @type {(inputs: Knp_Terms_Exported_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms exported to CSV`)
};

const fr_knp_terms_exported_csv = /** @type {(inputs: Knp_Terms_Exported_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termes exportés en CSV`)
};

const de_knp_terms_exported_csv = /** @type {(inputs: Knp_Terms_Exported_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begriffe in CSV exportiert`)
};

const it_knp_terms_exported_csv = /** @type {(inputs: Knp_Terms_Exported_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini esportati in CSV`)
};

const ru_knp_terms_exported_csv = /** @type {(inputs: Knp_Terms_Exported_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Термины экспортированы в CSV`)
};

const es_knp_terms_exported_csv = /** @type {(inputs: Knp_Terms_Exported_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos exportados a CSV`)
};

const zh_cn2_knp_terms_exported_csv = /** @type {(inputs: Knp_Terms_Exported_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出到 CSV 的术语`)
};

const ja_knp_terms_exported_csv = /** @type {(inputs: Knp_Terms_Exported_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSVにエクスポートされた用語`)
};

const hi_knp_terms_exported_csv = /** @type {(inputs: Knp_Terms_Exported_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV में निर्यात की गई शर्तें`)
};

const pt_pt2_knp_terms_exported_csv = /** @type {(inputs: Knp_Terms_Exported_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos exportados para CSV`)
};

/**
* | output |
* | --- |
* | "Terms exported to CSV" |
*
* @param {Knp_Terms_Exported_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_exported_csv = /** @type {((inputs?: Knp_Terms_Exported_CsvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Exported_CsvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_exported_csv(inputs)
	if (locale === "de") return de_knp_terms_exported_csv(inputs)
	if (locale === "it") return it_knp_terms_exported_csv(inputs)
	if (locale === "ru") return ru_knp_terms_exported_csv(inputs)
	if (locale === "es") return es_knp_terms_exported_csv(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_exported_csv(inputs)
	if (locale === "ja") return ja_knp_terms_exported_csv(inputs)
	if (locale === "hi") return hi_knp_terms_exported_csv(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_exported_csv(inputs)
	return en_knp_terms_exported_csv(inputs)
});